import React, { useState } from "react";
import "./Screen.css";
import Icard from "./Icard.js";
function Screen() {
  const [data, setData] = useState([
    {
      head: "A Tree For Me ",
      body: "because environment comes first",
      headsize: "1"
    },
    { head: "WHAT'S THIS WEBAPP ALL ABOUT?", body: "", headsize: "1" },
    {
      head: "*THIS LETS YOU REMOTELY ADOPT A TREE ON YOUR BEHALF ",
      body: "WITH NO WORRIES OF TAKING EVERYDAY CARE",
      headsize: "0"
    },
    {
      head: "* HOW to work on it? ",
      body: "select the 🍃 (leaf)-select the plant you want to adopt-nickname it-wait for sometime for notification ",
      headsize: "0"
    },
    { head: "* Where can i see my plants? ", body: "You can see your plants under profile section..the images are re-uploaded every week.So what are you waiting for? just scroll up and login!", headsize: "0" }
  ]);
  return (
    <div className="screen">
      {data.map((datas) => (
        <Icard
          head={datas.head}
          body={datas.body}
          headsize={datas.headsize}
        ></Icard>
      ))}
    </div>
  );
}

export default Screen;
